export {
  TopClassesPage,
  getStaticProps,
  getStaticPaths
} from "./TopClassesPage";
